export default {
  'dishPreference.title': '偏好分类',
  'dishPreference.field.name': '分类名',
  'dishPreference.field.foreign_name': '分类(中文名)',
  'dishPreference.field.option.index': '选项{index}',
  'dishPreference.field.option.name': '名称',
  'dishPreference.field.option.foreign_name': '中文名(可选填)',
  'dishPreference.field.option.price': '默认价格(可选填)',
  'dishPreference.field.default_custom_price': '默认价格选项',
  'dishPreference.field.linked_actions': '与以下动作关联',
  'dishPreference.field.linked_actions.description':
    '将该category与某个动作关联后：只有操作该动作，才会出现关联的category。',
  'dishPreference.action.delete': '删除此分类',
  'dishPreference.action.addMore': '添加更多选项',
  'dishPreference.action.addOptions': '添加选项',
  'dishPreference.name.isRequired': '分类名必填',
  'dishPreference.foreign_name.isRequired': '分类中文名必填',
  'dishPreference.name.existed': '此分类名已被使用',
  'dishPreference.foreign_name.existed': '此分类中文名已被使用',
  'dishPreference.option.name.isRequired': '选项名必填',
  'dishPreference.option.name.existed': '选项名已被使用',
  'dishPreference.option.foreign_name.existed': '选项中文名已被使用',
  'dishPreference.option.isApplied': '此选项已关联附加选项，请先解除关联关系再删除',
  'dishPreference.category.isApplied': '此分类已关联附加选项，请先解除关联关系再删除',
  'dishPreference.deletion.promptTitle': '删除提示',
  'dishPreference.deletion.promptContent': '确认要删除此偏好分类吗？',

  'dishPreference.restriction.title': '限制规则',
  'dishPreference.restriction.title.des': '目前仅对平板点餐和QR点餐生效，其他产品端正在逐步适配中，敬请期待',
  'dishPreference.restriction.selection': '选项限制',
  'dishPreference.restriction.selection.des':
    '比如选项有蛋黄酱、黄芥末酱、沙拉酱、洋葱甜酱、烧烤酱、蕃茄酱共6种可选项，但限制其中最少选择2种、最多选择4种。',
  'dishPreference.restriction.quantity': '份数限制',
  'dishPreference.restriction.quantity.des':
    '比如选项有牛肉、鸡肉、洋葱、辣椒、番茄、黄瓜等配料可选，不论选择什么、不论选择是否重复，最少选择2份、最多选择4份。',
  'dishPreference.restriction.maximum': '每项最多可选份数',
  'dishPreference.restriction.maximum.des': '比如有多种可选项，每一种选项，最多可以选择2份。',
  'dishPreference.restriction.min': '最少',
  'dishPreference.restriction.max': '最多',
  'dishPreference.savePrompt': '您修改的该选项关联了下列二级选项，请确认无误后保存更新。',
  'dishPreference.relatedCustomizations': '关联的附加选项 ({count})',
};
